export const useStyles = (theme) => ({
  root: {
    padding: 20,
    minHeight: "50vh",
    [theme.breakpoints.down(960)]: {},
  },
  emptyStyle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 30,
    fontWeight: "bold",
  },
  paginationStyle: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
